import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { SubText } from "@base-ui";
import { StyledHolder, styledSystemKeys } from "./message.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function MessageExpander(props) {
  var id = props.id,
    message = props.message,
    open = props.open,
    inverted = props.inverted,
    className = props.className,
    type = props.type;
  var messageMarkup = typeof message === "string" ? message === null || message === void 0 ? void 0 : message.split("\n").map(function (x, idx) {
    return /*#__PURE__*/_jsx(SubText, {
      inverted: inverted || type === "error",
      children: x
    }, idx);
  }) : message;
  return /*#__PURE__*/_jsx(StyledHolder, _objectSpread(_objectSpread({
    id: "".concat(id, "-section"),
    className: className,
    open: open,
    inverted: inverted,
    type: type
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsx("div", {
      style: {
        display: open ? "block" : "none"
      },
      children: messageMarkup
    })
  }));
}, function (prev, curr) {
  return equals(prev.open, curr.open) && equals(prev.message, curr.message);
});